import {makeStyles} from "@material-ui/core/styles";
import {baseTableCellStyles, baseTableFooterStyles} from "../../../../TradeStepV2/components/shared/sharedTableStyles";

const baseSummaryTableCellStyles = {
  whiteSpace: 'nowrap',

  '&:first-child': {
    width: 40
  },
  '&:last-child': {
    width: 115
  }
}

const useStyles = makeStyles(() => ({
  tableContainer: {
    overflowX: 'auto',
  },
  tableCell: {
    ...baseTableCellStyles,
    ...baseSummaryTableCellStyles,
  },
  tableFooter: {
    ...baseTableFooterStyles,
    '& $tableCell:nth-child(-n+3)': {
      background: '#fff',
    },
  },
  tableRow: {

  },
  tableHeader: {
    fontSize: 18,
  }
}));

export const useEinzeltitelStyles = makeStyles(() => ({
  tableContainer: {
    overflowX: 'auto',
  },
  tableCell: {
    ...baseTableCellStyles,
    ...baseSummaryTableCellStyles,
  },
  tableFooter: {
    ...baseTableFooterStyles,
    '& $tableCell:nth-child(-n+5)': {
      background: '#fff',
    },
  },
  tableRow: {

  },
}));

export default useStyles;
